module.exports = __webpack_public_path__ + "static/media/Food Hound.a505596a.gif";